import { render, staticRenderFns } from "./BullDiseaseScreening.vue?vue&type=template&id=2ad54e79&scoped=true&"
import script from "./BullDiseaseScreening.vue?vue&type=script&lang=js&"
export * from "./BullDiseaseScreening.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad54e79",
  null
  
)

export default component.exports